import { Component } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-signed-out-dialog',
  standalone: true,
  imports: [CommonModule, TranslateModule, MatButtonModule, MatDialogActions, MatDialogContent],
  templateUrl: './signed-out-dialog.component.html',
  styleUrl: './signed-out-dialog.component.scss'
})
export class SignedOutDialogComponent {
  constructor(public dialogRef: MatDialogRef<SignedOutDialogComponent>) {}

  // Re-login button click - closes the dialog so the caller can redirect the user to the login page
  onReLogin(): void {
    this.dialogRef.close('relogin');
  }
}
